import { Flex, Form, FormInstance, Select } from 'antd'
import { FormattedMessage } from 'react-intl'
import { FormValues } from '../../types'
import { formKeys } from '../DonationForm/constants'
import countries from './constants/countries.json'
import usaStates from './constants/usaStates.json'
import s from './s.module.css'
import { lang } from './lang'
import Label from '@/shared/components/Label'

type Option = {
  value: string
  label: string
}

type Props = {
  form: FormInstance<FormValues>
}

const countriesOptions: Option[] = countries.map(([name, code]) => ({
  value: code,
  label: name,
}))

const usaStatesOptions: Option[] = usaStates.map(([name, code]) => ({
  value: code,
  label: name,
}))

const filter = (input: string, opt?: Option) =>
  !!(opt?.value.toLowerCase().includes(input.toLowerCase()) || opt?.label.toLowerCase().includes(input.toLowerCase()))

export default function CountrySelect({ form }: Props) {
  const showStates = form.getFieldValue(formKeys.country) === 'US'

  return (
    <Flex gap={16}>
      <Form.Item
        name={formKeys.country}
        className={s.select}
        required
        label={
          <Label>
            <FormattedMessage {...lang.country} />
          </Label>
        }
        rules={[{ required: true, message: <FormattedMessage {...lang.countryRequired} /> }]}
      >
        <Select showSearch filterOption={filter} options={countriesOptions} size="large" />
      </Form.Item>
      {showStates ? (
        <Form.Item
          name={formKeys.state}
          className={s.select}
          required
          label={
            <Label>
              <FormattedMessage {...lang.state} />
            </Label>
          }
          rules={[{ required: true, message: <FormattedMessage {...lang.stateRequired} /> }]}
        >
          <Select showSearch filterOption={filter} options={usaStatesOptions} size="large" />
        </Form.Item>
      ) : null}
    </Flex>
  )
}
